import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'device_id';
const SUCCESSFUL_LOGIN_KEY = 'last_successful_login';
const DEVICE_TRUSTED_KEY = 'device_trusted';

class DeviceTrustService {
    constructor() {
        // Only get existing device ID if the device is trusted
        const isTrusted = localStorage.getItem(DEVICE_TRUSTED_KEY) === 'true';
        const existingDeviceId = localStorage.getItem(DEVICE_ID_KEY);
        
        if (isTrusted && existingDeviceId) {
            this.deviceId = existingDeviceId;
        } else {
            this.deviceId = this.generateNewDeviceId();
        }
    }

    generateNewDeviceId() {
        const deviceId = uuidv4();
        localStorage.setItem(DEVICE_ID_KEY, deviceId);
        return deviceId;
    }

    getDeviceId() {
        return this.deviceId;
    }

    setSuccessfulLogin() {
        const timestamp = new Date().getTime();
        localStorage.setItem(SUCCESSFUL_LOGIN_KEY, timestamp.toString());
        localStorage.setItem(DEVICE_TRUSTED_KEY, 'true');
        // Ensure device ID is stored
        localStorage.setItem(DEVICE_ID_KEY, this.deviceId);
    }

    isDeviceTrusted() {
        const lastLoginStr = localStorage.getItem(SUCCESSFUL_LOGIN_KEY);
        const isTrusted = localStorage.getItem(DEVICE_TRUSTED_KEY) === 'true';
        const hasDeviceId = localStorage.getItem(DEVICE_ID_KEY) === this.deviceId;
        
        if (!lastLoginStr || !isTrusted || !hasDeviceId) return false;

        const lastLogin = parseInt(lastLoginStr, 10);
        const now = new Date().getTime();
        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;

        const isWithinTimeLimit = (now - lastLogin) < thirtyDaysInMs;
        
        if (!isWithinTimeLimit) {
            this.removeTrust();
            return false;
        }

        return true;
    }

    shouldShowCaptcha() {
        return !this.isDeviceTrusted();
    }

    clearTrust() {
        localStorage.removeItem(SUCCESSFUL_LOGIN_KEY);
        localStorage.removeItem(DEVICE_TRUSTED_KEY);
        localStorage.removeItem(DEVICE_ID_KEY);
        this.deviceId = this.generateNewDeviceId();
    }

    removeTrust() {
        localStorage.removeItem(SUCCESSFUL_LOGIN_KEY);
        localStorage.removeItem(DEVICE_TRUSTED_KEY);
        localStorage.removeItem(DEVICE_ID_KEY);
        this.deviceId = this.generateNewDeviceId();
    }
}

export default new DeviceTrustService(); 